import { useTranslation } from 'react-i18next';
import { TaskType } from '@monorepo/shared';
import type { TaskCountsByTypeDto } from '@monorepo/shared';
import { DashboardWidget } from '../dashboard/DashboardWidget';

interface TaskTypeCountersProps {
  counts: TaskCountsByTypeDto | undefined;
}

const variantByTaskType = {
  [TaskType.VALIDATION]: 'highlight',
  [TaskType.DIFFUSION]: 'blue',
  [TaskType.READ]: 'default',
} as const;

export const TaskTypeCounters = ({ counts }: TaskTypeCountersProps) => {
  const { t } = useTranslation();

  if (!counts) {
    return null;
  }

  const entries = [
    { type: TaskType.VALIDATION, count: counts.validation },
    { type: TaskType.DIFFUSION, count: counts.diffusion },
    { type: TaskType.READ, count: counts.read },
  ];

  return (
    <div className="grid grid-cols-1 gap-4 px-4 pb-4 pt-4 sm:grid-cols-3 sm:px-6">
      {entries.map(({ type, count }) => (
        <DashboardWidget
          key={type}
          value={count}
          label={t(`tasks.counters.${type}`, { count })}
          variant={variantByTaskType[type]}
        />
      ))}
    </div>
  );
};
